class BouncePrenvention {
    /**
     * Handle all flows of bounce prevention of onboarding.
     * @constructor
     */
    constructor() {
        this.onMouseLeavePage = this.onMouseLeavePage.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        /**
         * No gestures have been done for 10 seconds timeout.
         * A Number, representing the ID value of the timer that is set.
         * @type {integer}
         * @public
         */
        this.timeout = null;
        /**
         * Observer for detecting if gestures we're done by observing if UI of crxmouse-extension was added to DOM.
         * @type {MutationObserver}
         * @public
         */
        this.observe = null;
        /**
         * Handler to call if user didn't do any gestures for 10 seconds.
         * @type {function}
         * @public
         */
        this.noGesturesHandler = null;
        /**
         * Handler that is been passed when starting to detect user's bounce - move mouse outside page for more than 300 millisecond.
         * @type {function}
         * @public
         */
        this.bounceHandler = null;
        /**
         * X coordinate of mouse
         * @type {integer}
         * @public
         */
        this.xCoordinateMouse = 0;
        /**
         * Y coordinate of mouse
         * @type {integer}
         * @public
         */
        this.yCorrdinateMouse = 0;
    }

    /**
     * Setting timeout to detect no gestures we're done for 10 seconds.
     * @private
     */
    setTimeoutNoGestures() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            this.noGesturesHandler();
            clearTimeout(this.timeout);
            this.timeout = null;
        }, 10000);
    }

    /**
     * On mouse move update the x and y coordinates
     * @param {event} event - Mouse move event
     * @private
     */
    onMouseMove(event) {
        this.xCoordinateMouse = event.pageX;
        this.yCorrdinateMouse = event.pageY;
    }

    /**
     * Check on mouse leave event if user stayed outside of the page for a 300 millisecond.
     * @param {event} event - Mouse leave event
     * @private
     */
    onMouseLeavePage(event) {
        const xCoordinateMouseBefore = this.xCoordinateMouse;
        const yCoordinateMouseBefore = this.yCorrdinateMouse;
        if(event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
            setTimeout(() => {
                if (xCoordinateMouseBefore === this.xCoordinateMouse && yCoordinateMouseBefore === this.yCorrdinateMouse) {
                    document.removeEventListener('mousemove', this.onMouseMove);
                    document.removeEventListener('mouseleave', this.onMouseLeavePage);
                    this.bounceHandler();
                }
            },  300);
        }
    }

    /**
     * Observing if user didn't do any gestures for 10 seconds.
     * @param {function} handler - The function that should be call after 10 seconds without user's gestures.
     */
    startObserving(handler) {
        this.noGesturesHandler = handler;
        if (this.observe !== null) {
            this.observe.disconnect();
        }

        const body = document.body;
        const config = {childList: true};

        this.observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.id === 'svgdivjlgkpaicikihijadgifklkbpdajbkhjo') {
                            if (this.timeout === null) {
                                this.observer.disconnect();
                                return;
                            }
                            this.setTimeoutNoGestures();
                        }
                    });
                }
            });
        });
        this.observer.observe(body, config);
        this.setTimeoutNoGestures();
    }

    /**
     * Detecting bounce of user - move mouse outside of the page for a 300 milliseconds
     * @param {function} handler - function to execute after user's bounce is detected.
     */
    startBouncePrevention(handler) {
        this.stopBouncePrevention();
        this.bounceHandler = handler;
        document.addEventListener("mousemove", this.onMouseMove);
        document.addEventListener("mouseleave", this.onMouseLeavePage);
    }


    stopBouncePrevention() {
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseleave", this.onMouseLeavePage);
    }

}

export default new BouncePrenvention();
